(() => {
  const script = document.getElementById('WaveStoryTracking');
  const consent = window.SBAnalyticsConsent;
  if (!script || script.dataset.track !== 'true' || !consent || window.Shopify?.designMode) return;
  const root = document.querySelector('[data-wave-story]');
  const key = 'sb-wave-story-visitor';
  const duration = 30 * 86400000;
  let visitor = null;
  let syncing = null;
  const pending = new Set();
  try { visitor = JSON.parse(localStorage.getItem(key)); } catch (_) {}
  if (!visitor?.id || !Number.isFinite(Date.parse(visitor.at)) || Date.now() - Date.parse(visitor.at) > duration) visitor = null;
  const allowed = () => consent.analyticsAllowed() === true && !Object.values(window.SBActiveExperiments || {}).some(test => test.forced);
  const save = () => { try { if (visitor) localStorage.setItem(key, JSON.stringify(visitor)); else localStorage.removeItem(key); } catch (_) {} };
  const attributes = () => ({ sb_story: allowed() && visitor?.accepted ? 'wave-pro-2-story' : '', sb_story_visitor: allowed() && visitor?.accepted ? visitor.id : '', sb_story_enrolled_at: allowed() && visitor?.accepted ? visitor.at : '', sb_story_eligible: allowed() && visitor?.accepted ? 'true' : '' });
  const sync = () => {
    document.querySelectorAll('[data-cart-checkout-button]').forEach(button => {
      const form = button.closest('form');
      if (!form) return;
      Object.entries(attributes()).forEach(([name, value]) => {
        let input = form.querySelector(`[name="attributes[${name}]"]`);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `attributes[${name}]`; form.append(input); }
        input.value = value;
      });
    });
    const cart = window.SBCart?.getCart?.();
    if (syncing || !cart?.item_count || !window.SBCart?.updateAttributes) return syncing;
    const values = attributes();
    if (Object.entries(values).every(([k, v]) => `${cart.attributes?.[k] || ''}` === v)) return;
    syncing = window.SBCart.updateAttributes(values, { source: 'shopping-story' }).catch(() => {}).finally(() => { syncing = null; if (JSON.stringify(values) !== JSON.stringify(attributes())) sync(); });
    return syncing;
  };
  const send = async (kind, chapter = '') => {
    if (!allowed() || !visitor || document.visibilityState === 'hidden') return;
    if (kind !== 'landing' && !visitor.accepted) return;
    const flag = `${kind}:${chapter}`;
    if (visitor.sent?.includes(flag) || pending.has(flag)) return;
    pending.add(flag);
    const enrollment = visitor;
    try {
      const response = await fetch('https://a.klaviyo.com/client/events/?company_id=MiSQ6e', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-04-15' }, keepalive: true, body: JSON.stringify({ data: { type: 'event', attributes: { unique_id: `${enrollment.id}:${flag}`, time: kind === 'landing' ? enrollment.at : new Date().toISOString(), properties: { story: 'wave-pro-2-story', kind, chapter, visitor: enrollment.id, enrolled_at: enrollment.at, campaign: enrollment.campaign }, metric: { data: { type: 'metric', attributes: { name: 'soundbrenner.com shopping story' } } }, profile: { data: { type: 'profile', attributes: { anonymous_id: enrollment.id } } } } } }) });
      if (!response.ok || !allowed() || enrollment !== visitor) return;
      enrollment.sent ||= []; enrollment.sent.push(flag);
      if (kind === 'landing') enrollment.accepted = true;
      save(); sync();
    } catch (_) {} finally { pending.delete(flag); }
  };
  const ready = async () => {
    if (consent.analyticsAllowed() === null) return;
    if (!allowed()) { visitor = null; save(); sync(); return; }
    if (!visitor && root?.dataset.track === 'true') { visitor = { id: crypto.randomUUID(), at: new Date().toISOString(), campaign: new URL(location.href).searchParams.get('utm_campaign') || '', sent: [] }; save(); }
    if (root) { await send('landing'); await send('chapter', root.querySelector('[data-story-progress][aria-current]')?.hash.slice(1) || 'story-hook'); }
    sync();
  };
  consent.whenReady(() => { void ready(); });
  document.addEventListener('visibilitychange', () => { if (allowed()) void ready(); });
  document.addEventListener('sb:cart-system-ready', sync);
  document.addEventListener('cart:updated', event => {
    const { cart, previousCart, source } = event.detail || {};
    if (root && previousCart && /add/i.test(source || '') && cart?.item_count > previousCart.item_count) void send('successful_add');
    sync();
  });
  root?.addEventListener('wave-story:chapter', event => { void send('chapter', event.detail.chapter); });
  root?.addEventListener('wave-story:shortcut', () => { void send('shortcut'); });
  consent.onCheckout(sync);
  void ready();
})();
